import { render } from "./NcrmMailjetDataPanel.vue?vue&type=template&id=d180c744&scoped=true"
import script from "./NcrmMailjetDataPanel.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetDataPanel.vue?vue&type=script&lang=js"

import "./NcrmMailjetDataPanel.vue?vue&type=style&index=0&id=d180c744&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d180c744"]])

export default __exports__